<template>
    <tbody v-if="councilApplications(councilAreaId).length > 0">
        <tr >
            <th colspan="5" style="font-weight:bold;">{{ councilAreaName}}</th>
        </tr>
        <tr v-for="row in councilApplications(councilAreaId)" :key="row.id"  >
        
            <td>{{row.forename}} {{row.surname}}</td>
            
            <td>{{ row.governing_body_short_name }}</td>
            <td>{{ showApplicationStatus(row.endorsed, row.awarded)}}</td>
            <td >{{ row.amount }}</td>
        
        </tr>
    </tbody>

</template>

<script>


export default {
    
  components: {
   	
  },
  props: ['applications', 'councilAreaName', 'councilAreaId'],
  methods: {
  councilApplications: function(councilAreaId) {
    return this.applications.filter(function(u) {
         return u.council_area_id === councilAreaId
     })
  },
  
   
 
} 
}
</script>